// Cervly storefront interactions: gallery, bundles, qty, ATC, sticky bar, FAQ, mobile nav, email signup
(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function fmtMoney(cents) {
    const fmt = (window.cervly && window.cervly.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount(_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?\s*\}\}/g, withCommas);
  }

  // ---------- PDP gallery ----------
  function initGallery() {
    const gal = $('.gallery');
    if (!gal) return;
    const main = $('.g-main img, .g-main .ph', gal);
    const tag = $('.g-tag', gal);
    const thumbs = $$('.g-thumb', gal);
    thumbs.forEach((t) => {
      t.addEventListener('click', () => {
        thumbs.forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
        const src = t.dataset.src;
        const newTag = t.dataset.tag || '';
        if (src && main && main.tagName === 'IMG') main.src = src;
        if (tag) {
          if (newTag) {
            tag.textContent = newTag;
            tag.style.display = '';
          } else {
            tag.style.display = 'none';
          }
        }
      });
    });
  }

  // ---------- PDP bundle selector + qty + ATC ----------
  function initBuyBox() {
    const buy = $('.buy');
    if (!buy) return;

    const bundles = $$('.bundle', buy);
    const qtyEl = $('.qty span', buy);
    const decBtn = $('.qty button[data-act="dec"]', buy);
    const incBtn = $('.qty button[data-act="inc"]', buy);
    const atc = $('.atc', buy);
    const nowPrice = $('.price .now', buy);
    const wasPrice = $('.price .was', buy);
    const savePill = $('.price .savepill', buy);
    const perUnit = $('.perunit', buy);
    const stickyBar = $('.sticky-bar');
    const stickyTotal = stickyBar ? $('.sticky-r .spr', stickyBar) : null;
    const stickySp = stickyBar ? $('.sticky-l .sp', stickyBar) : null;
    const stickyAtc = stickyBar ? $('.sticky-r .btn', stickyBar) : null;

    const gMainImg = $('.g-main img');
    const gThumbEls = $$('.g-thumb');
    const gOriginal = gMainImg ? gMainImg.getAttribute('src') : null;

    let qty = 1;
    let selected = bundles.findIndex((b) => b.classList.contains('sel'));
    if (selected < 0) selected = 0;

    function bundleData(el) {
      return {
        variantId: el.dataset.variantId,
        price: parseInt(el.dataset.price, 10),       // cents
        was: parseInt(el.dataset.was || '0', 10),    // cents
        units: parseInt(el.dataset.units || '1', 10),
        name: el.dataset.name,
      };
    }

    function render() {
      const el = bundles[selected];
      if (!el) return;
      const b = bundleData(el);
      const total = b.price * qty;
      if (nowPrice) nowPrice.textContent = fmtMoney(b.price);
      if (wasPrice) wasPrice.textContent = b.was ? fmtMoney(b.was) : '';
      if (savePill) savePill.textContent = b.was ? 'Save ' + fmtMoney(b.was - b.price) : '';
      if (atc) atc.querySelector('.atc-label').textContent = 'Add to cart';
      if (stickyAtc && !stickyAtc.dataset.added) (stickyAtc.querySelector('.atc-label') || stickyAtc).textContent = 'Add to cart';
      if (qtyEl) qtyEl.textContent = qty;
      if (stickyTotal) stickyTotal.textContent = fmtMoney(total);
      if (stickySp) {
        const perCents = Math.round(b.price / b.units);
        stickySp.textContent = b.name;
      }
    }

    bundles.forEach((el, i) => {
      el.addEventListener('click', () => {
        bundles.forEach((x) => x.classList.remove('sel'));
        el.classList.add('sel');
        selected = i;
        if (gMainImg) {
          if (el.dataset.image) {
            gMainImg.src = el.dataset.image;
            gThumbEls.forEach((t) => t.classList.remove('active'));
          } else if (gOriginal) {
            gMainImg.src = gOriginal;
            gThumbEls.forEach((t, ti) => t.classList.toggle('active', ti === 0));
          }
        }
        render();
      });
    });

    if (decBtn) decBtn.addEventListener('click', () => { qty = Math.max(1, qty - 1); render(); });
    if (incBtn) incBtn.addEventListener('click', () => { qty = qty + 1; render(); });

    function addToCart(btn) {
      const el = bundles[selected];
      if (!el) return;
      const id = el.dataset.variantId;
      if (!id) {
        flash(btn, 'Variant missing');
        return;
      }
      btn.disabled = true;
      (btn.querySelector('.atc-label') || btn).textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: (function () {
          const items = [{ id: parseInt(id, 10), quantity: qty }];
          if (el.dataset.extraVariantId) items.push({ id: parseInt(el.dataset.extraVariantId, 10), quantity: 1 });
          return items;
        })() })
      })
        .then((r) => r.json())
        .then(() => {
          updateCartCount();
          btn.classList.add('added');
          (btn.querySelector('.atc-label') || btn).textContent = 'Added ✓';
          window.location.href = '/cart';
        })
        .catch(() => { flash(btn, 'Try again'); })
        .finally(() => { btn.disabled = false; });
    }

    function flash(btn, msg) {
      const label = btn.querySelector('.atc-label') || btn;
      const original = label.textContent;
      btn.classList.add('added');
      label.textContent = msg;
      setTimeout(() => {
        btn.classList.remove('added');
        render();
      }, 1700);
    }

    if (atc) atc.addEventListener('click', (e) => { e.preventDefault(); addToCart(atc); });
    if (stickyAtc) stickyAtc.addEventListener('click', (e) => {
      e.preventDefault();
      if (stickyAtc.dataset.added) { window.location.href = '/cart'; return; }
      addToCart(stickyAtc);
    });

    render();
  }

  function updateCartCount() {
    fetch('/cart.js').then((r) => r.json()).then((cart) => {
      $$('.js-cart-count').forEach((el) => {
        el.textContent = '(' + cart.item_count + ')';
      });
      $$('.js-cart-bubble').forEach((el) => {
        el.textContent = cart.item_count;
      });
    });
  }

  // ---------- sticky bar visibility ----------
  function initStickyBar() {
    const bar = $('.sticky-bar');
    const buy = $('.buy');
    const final = $('.final');
    if (!bar || !buy) return;

    function update() {
      const buyRect = buy.getBoundingClientRect();
      const finalRect = final ? final.getBoundingClientRect() : null;
      const showFromBuy = buyRect.bottom < 40;
      const hideForFinal = finalRect && finalRect.top < window.innerHeight - 80;
      if (showFromBuy && !hideForFinal) bar.classList.add('show');
      else bar.classList.remove('show');
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // ---------- FAQ accordion ----------
  function initFaq() {
    $$('.faq-item').forEach((item, idx) => {
      const q = $('.faq-q', item);
      const a = $('.faq-a', item);
      if (!q || !a) return;
      if (idx === 0) {
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
      q.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        // single-open
        $$('.faq-item').forEach((other) => {
          other.classList.remove('open');
          const oa = $('.faq-a', other);
          if (oa) oa.style.maxHeight = 0;
        });
        if (!isOpen) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  // ---------- mobile nav toggle ----------
  function initNav() {
    const toggle = $('.nav-toggle');
    const drawer = $('.nav-drawer');
    if (toggle && drawer) {
      toggle.addEventListener('click', () => drawer.classList.toggle('open'));
    }
  }

  // ---------- email signup (Shopify Customer API) ----------
  function initEmailForm() {
    $$('form.community-form').forEach((f) => {
      f.addEventListener('submit', (e) => {
        // Let Shopify handle the actual submission via standard /contact form
      });
    });
  }

  // ---------- cart page (qty change + remove) ----------
  function initCartPage() {
    const items = $$('.cart-row');
    if (!items.length) return;

    function changeLine(key, qty) {
      const row = document.querySelector('.cart-row[data-key="' + key + '"]');
      if (row) row.classList.add('updating');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then((r) => r.json())
        .then(() => { window.location.reload(); });
    }

    $$('.cart-row .qty button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const row = btn.closest('.cart-row');
        const span = row.querySelector('.qty span');
        let q = parseInt(span.textContent, 10);
        if (btn.dataset.act === 'inc') q += 1;
        else q = Math.max(0, q - 1);
        span.textContent = '…';
        row.querySelectorAll('.qty button').forEach((b) => { b.disabled = true; });
        changeLine(key, q);
      });
    });

    $$('.cart-remove').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.textContent = 'Removing…';
        changeLine(btn.dataset.key, 0);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initNav();
    initGallery();
    initBuyBox();
    initStickyBar();
    initFaq();
    initEmailForm();
    initCartPage();
    updateCartCount();
  });
})();
